<template>
  <div class="general-background" style="font-family: cerebriSansReg">
    <b-row>
      <template v-for="(visit, index) in visitors">
        <b-col cols="6" :key="index">
          <b-card no-body class="overflow-hidden" style="max-width: 540px; margin: 20px;">
            <template v-slot:header>
              <template v-if="visit.state == 'Waiting'">
                <h4 class="mb-0">User has been notified</h4>
              </template>
              <template v-if="visit.state == 'Acknowledged'">
                <h4 class="mb-0">User has confirmed your arrival</h4>
              </template>
              <template v-if="visit.state == 'Delayed'">
                <h4 class="mb-0">User has not answered</h4>
              </template>
            </template>
            <b-row no-gutters>
              <b-col md="6">
                <b-list-group flush>
                  <b-list-group-item>Status: {{visit.state}}</b-list-group-item>
                  <b-list-group-item>Waiting Time: {{visit.elapsedTime}}</b-list-group-item>
                  <template v-if="visit.state == 'Delayed'">
                    <b-list-group-item>Check with guard</b-list-group-item>
                  </template>
                  <template v-else>
                    <b-list-group-item>Please wait</b-list-group-item>
                  </template>
                </b-list-group>
              </b-col>
              <b-col md="6">
                <b-card-body :title="visit.visitName">
                  <b-card-text>User: {{visit.ownerName}}</b-card-text>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </template>
    </b-row>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/firestore";

export default {
  name: "VisitMonitor",
  props: {
    userJSON: {}
  },
  data: () => ({
    visitors: [],
    timer: null
  }),
  mounted() {
    var self = this;
    this.unsubscribe = firebase
      .firestore()
      .collection("users")
      .doc(self.userJSON.id)
      .collection("visitors")
      .onSnapshot(function(querySnapshot) {
        var formsArray = [];
        querySnapshot.forEach(function(doc) {
          if (doc.data().arrivalTT) {
            var tempDoc = doc.data();
            tempDoc.cardID = doc.id;
            tempDoc.show = false;
            var seconds = Date.now() - tempDoc.arrivalTT;
            var elapsedTime = new Date(seconds).toISOString().substr(11, 8);
            tempDoc.elapsedTime = elapsedTime;
            if (tempDoc.ack) {
              tempDoc.state = "Acknowledged";
            } else {
              tempDoc.state = "Waiting";
            }
            formsArray.push(tempDoc);
          }
        });
        self.visitors = formsArray;
      });

    this.timer = setInterval(function() {
      if (self.visitors.length > 0) {
        self.visitors.forEach((element, index) => {
          var seconds = Date.now() - element.arrivalTT;
          var elapsedTime = new Date(seconds).toISOString().substr(11, 8);
          self.visitors[index].elapsedTime = elapsedTime;
        });
      }
    }, 5000);
  },
  destroyed() {
    this.unsubscribe();
    clearInterval(this.timer);
  }
};
</script>

<style>
</style>